import api from "./axios";


export const deleteAccountFinal = async (id) => {
    try {
        const response = await api.delete(`/api/v1/customer/setting/delete/${id}`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong")
    }
}

export const deleteAccountReasons = async (data) => {
    try {
        const response = await api.post(`/api/v1/customer/setting/delete-reason`,data);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong")
    }
}

export const pauseAccount = async () => {
    try {
        const response = await api.put(`/api/v1/customer/setting/pause`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong")
    }
}
export const cancelSubscription = async () => {
    try {
        const response = await api.post(`/api/v1/customer/subscription/cancel`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong")
    }
}
export const verifyOtp = async (data) => {
    try {
        const response = await api.put(`/api/v1/customer/setting/verifyotp`,data);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong")
    }
}
export const updateNumberOtp = async (data) => {
    try {
      const response = await api.post(
        `/api/v1/customer/setting/updatephone/otp`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(error.response?.data?.message || "Something went wrong");
      const message =
        error.response?.data?.message || "Error fetching payment methods.";
      throw {
        ...error,
        message,
      };
    }
}
export const updatePhoneNumber = async (data) => {
    try {
        const response = await api.post(`/api/v1/customer/setting/updatephone`,data);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong")
    }
}